export default {
    RECORDING: 'RECORDING',
    SPEAKING:  'SPEAKING',
    SENDING: 'SENDING',
    NONE: 'NONE'
  }